export const entityName = "vendors-table";

export const tableColumns = [
  { label: "Name", queryKey: "name", required: true },
  { label: "Api type", queryKey: "api_type", required: true },
  { label: "Status", queryKey: "name" },
  { label: "Created at", queryKey: "createdAt" },
  { label: "", queryKey: "" },
];
